// extracted by mini-css-extract-plugin
export default {"status":"status_status__idZAY","color":"status_color__dsAOl","green":"status_green__5kNi2","red":"status_red__rvXEP"};